import { sql } from 'drizzle-orm';
import {
  boolean,
  foreignKey,
  index,
  pgTable,
  unique,
  uniqueIndex,
  uuid,
  varchar,
} from 'drizzle-orm/pg-core';
import {
  defaultFields,
  defaultHistoryFields,
} from '@trashlab/api/drizzle/default';
import { organization } from '@trashlab/api/src/domains/identity/schemas/organization';

export const merchant_account = pgTable(
  'merchant_account',
  {
    ...defaultFields.fieldsWithTenantId(),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
    tilledAccountId: varchar('tilledAccountId').notNull(),
    displayName: varchar('displayName').notNull(),
    isDefault: boolean('isDefault').default(false).notNull(),
    isLegacy: boolean('isLegacy').default(false).notNull(),
  },
  (table) => ({
    tenant_account_unique: unique('merchant_account_tenant_account_unique').on(
      table.tenantId,
      table.tilledAccountId,
    ),
    active_account_unique: uniqueIndex('merchant_account_active_account_unique')
      .on(table.tilledAccountId)
      .where(sql`${table.archivedAtTs} IS NULL`),
    active_default_unique: uniqueIndex('merchant_account_active_default_unique')
      .on(table.tenantId)
      .where(sql`${table.isDefault} AND ${table.archivedAtTs} IS NULL`),
    legacy_account_unique: uniqueIndex('merchant_account_legacy_account_unique')
      .on(table.tenantId)
      .where(sql`${table.isLegacy}`),
    tenantId_idx: index('merchant_account_tenantId_idx').on(table.tenantId),
    tilledAccountId_idx: index('merchant_account_tilledAccountId_idx').on(
      table.tilledAccountId,
    ),
    tenantId_fkey: foreignKey({
      columns: [table.tenantId],
      foreignColumns: [organization.id],
      name: 'merchant_account_tenantId_fkey',
    }),
  }),
);

export const merchant_account_history = pgTable('merchant_account_history', {
  ...defaultHistoryFields.historyFieldsWithTenantId(),
  lastModifiedBy: uuid('lastModifiedBy'),
  createdBy: uuid('createdBy'),
  tilledAccountId: varchar('tilledAccountId'),
  displayName: varchar('displayName'),
  isDefault: boolean('isDefault'),
  isLegacy: boolean('isLegacy'),
});

export type MerchantAccount = typeof merchant_account.$inferSelect;
